@switch ($buttonType()) {
  @case (btnTypes.Edit) {
    <button
      boelsButton
      edit
      [variant]="$buttonConfig().variant ?? 'secondary'"
      [shape]="$buttonConfig().shape ?? 'square'"
      [icon]="faEditIcon"
      (click)="addToCartModal($orderEntry())"
    >
      {{ 'addToCartButton.btnLabelEdit' | transloco }}
    </button>
  }
  @case (btnTypes.AddToCart) {
    <button
      boelsButton
      [icon]="faShoppingBasketIcon"
      [variant]="$buttonConfig().variant ?? 'secondary'"
      [shape]="$buttonConfig().shape ?? 'square'"
      (click)="addToCartModal()"
    >
      {{ 'addToCartButton.btnLabel' | transloco }}
    </button>
  }
  @case (btnTypes.Variants) {
    <button
      boelsButton
      [variant]="$buttonConfig().variant ?? 'secondary'"
      [shape]="$buttonConfig().shape ?? 'square'"
      [icon]="faCloneIcon"
      [routerLink]="$product().url"
    >
      {{ 'addToCartButton.btnLabelVariant' | transloco }}
    </button>
  }
  @case (btnTypes.RequestQuote) {
    <button
      boelsButton
      [icon]="faFileLines"
      [variant]="$buttonConfig().variant ?? 'secondary'"
      [shape]="$buttonConfig().shape ?? 'square'"
      (click)="onRequestQuoteButtonClick()"
    >
      {{ 'addToCartButton.btnQuotation' | transloco }}
    </button>
  }
}
